const CommonAPI = {
  API_ROOT_URL: 'employee',
};

export default CommonAPI;
